import React from 'lib/react';
import {
  EVButton,
  EVPaper, EVTypography, makeStyles,
} from 'lib/components';
import clsx from 'lib/clsx';
import { useTranslation } from 'lib/translation';
import useMediaQuery from 'hooks/useMediaQuery';

const useStyles = makeStyles((theme) => ({
  noOrdersScreen: {
    margin: '16px',
    padding: '16px 0',
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '20px',
  },
  noOrders: {
    boxShadow: 'none',
    flexDirection: 'column',
    height: '100%',
  },
  placeOrderBtn: {
    height: '36px',
    backgroundColor: theme.evPalette.ocean[600],
    padding: '10px',
    radius: '4px',
    gap: '8px',
  },
  placeOrderLabel: {
    columnGap: '8px',
    padding: 0,
    alignItems: 'center',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '10px',
    textTransform: 'none',
  },
  message: {
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '32px',
    color: '#000000',
    textAlign: 'center',
  },
}));

function NoOrdersScreen() {
  const classes = useStyles();
  const { t } = useTranslation();
  const isMobile = useMediaQuery(640);

  return (
    <EVPaper square={isMobile} className={clsx(classes.noOrdersScreen, classes.noOrders)}>
      <EVTypography className={classes.message}>{t('order_history__no_orders_placed')}</EVTypography>
      <EVButton
        id="placeOrderButton"
        variant="contained"
        color="primary"
        className={classes.placeOrderBtn}
        classes={{ label: classes.placeOrderLabel }}
        href="order"
      >
        {t('order_history__place_order')}
      </EVButton>
    </EVPaper>
  );
}

export default NoOrdersScreen;
